<template>
  <div class="esp_page_footer">
    <div>
      <slot name="left"></slot>
    </div>
    <div>
      <slot></slot>
    </div>
    <div>
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EspPageFooter',
    data() {
      return {}
    }
  }
</script>

<style scoped lang="less">
  .esp_page_footer {
    display: -webkit-flex;
    display: flex;
    padding: 0px 10px 5px 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    & > div {
      -webkit-box-flex: 1;
      flex: 1;

      &:last-of-type {
        text-align: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/EspPageFooter.vue